import { useLocation } from "react-router-dom";
import EnterpriseCustomers from "./EnterpriseCustomers";


export const EnterpriseNotifPage = () => {
    const location = useLocation();
    return <EnterpriseCustomers key={location.key} />
 }